import { DataTypeEnum } from "../../enums/DataTypeEnum";
import { ColumnType } from "../../enums/DRCXEnums";

export function makeSelectedTagEquatableKey(
    columnType: ColumnType | undefined,
    tatID: number | undefined,
    tatTypeID: number | undefined,
    dataType: DataTypeEnum | undefined
): string {
    return columnType === ColumnType.TatType
        ? `${ColumnType.TatType}:${typeof tatTypeID === "number" ? tatTypeID : ""}:${typeof dataType === "number" ? dataType : ""}`
        : `${ColumnType.Tat}:${typeof tatID === "number" ? tatID : ""}:${typeof dataType === "number" ? dataType : ""}`;
}
